import type { ReactNode } from 'react';
import PropTypes from 'prop-types';

// generic types
import type { colors, animation } from '../generic';
import { propTypesColors, propTypesAnimation } from '../generic';

/**
 * This file contains the types and prop-types for Navbar component.
 */

// typescript types
export type variant = 'filled' | 'gradient';
export type color = 'transparent' | 'white' | colors;
export type shadow = boolean;
export type blurred = boolean;
export type fullWidth = boolean;
export type className = string;
type children = ReactNode;
type open = boolean;
type animate = animation;

// javascript prop-types
export const propTypesVariant: any = ['filled', 'gradient'];
export const propTypesColor: any = ['transparent', 'white', ...propTypesColors];
const propTypesShadow: any = PropTypes.bool;
const propTypesBlurred: any = PropTypes.bool;
const propTypesFullWidth: any = PropTypes.bool;
const propTypesClassName: any = PropTypes.string;
const propTypesChildren: any = PropTypes.node.isRequired;
const propTypesOpen: any = PropTypes.bool.isRequired;
const propTypesAnimate: any = propTypesAnimation;
